<template>
  <b-form class="py-4">
    <b-form-row>
      <b-col class="mx-2" style="text-align: center !important">
        <span class="sg-sub-heading-text">
          Sign In
        </span>
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="10" lg="6">
        <b-input-group
          label="Email"
          label-for="input-email-login"
          label-sr-only
        >
          <b-form-input
            id="input-email-login"
            placeholder="Email"
            v-model="user.email"
            type="email"
          />
        </b-input-group>
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="10" lg="6">
        <b-input-group
          label="Password"
          label-for="input-password-login"
          label-sr-only
        >
          <b-form-input
            id="input-password-login"
            placeholder="Password"
            v-model="user.password"
            type="password"
          />
        </b-input-group>
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-4">
      <b-col cols="3">
        <b-button variant="success" @click="loginUser" :disabled="login_button_state">
          Sign In
        </b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component

// api call
import AuthenticationAPI from '@/api/AuthenticationAPI'
import PaymentAPI from '@/api/PaymentAPI'

export default {
  name: 'FormLogin',
  props: ['whereTo'],
  data () {
    return {
      user: {
        email: '',
        password: ''
      },

      login_button_state: false,
      errors: []
    }
  },
  computed: {
  },
  methods: {
    // PREREQUISITES
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    // END PREREQUISITES

    // HTTP REQUEST
    loginUser: async function () {
      this.login_button_state = true
      this.errors = []

      if (!this.user.password) { this.errors.push('Password Required.') }

      if (!this.user.email) {
        this.errors.push('Email required.')
      } else if (!this.validEmail(this.user.email)) {
        this.errors.push('Invalid email format.')
      }

      if (this.errors.length) {
        swal({
          title: 'Please check your input.',
          text: this.errors[0],
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })

        this.login_button_state = false
      } else {
        try {
          const response = await AuthenticationAPI.loginUser(this.user)
          if (response.data.token) {
            this.$session.start()
            this.$session.set(`jwt`, response.data.token)
            this.$cookies.set(`user_session`, response.data.token)

            // It supposed to use this to login and save session, need to research about this
            // Vue.http.headers.common['Authorization'] = 'Bearer ' + response.data.token

            if (response.data.user.is_guider) {
              // kalau status pending_payment & tidak ada sg_payment yg terbuat

              const response2 = await PaymentAPI.fetchByParam({
                select: 'sg_user_id status',
                query: { is_delete: false, sg_user_id: response.data.user._id },
                populate: 'sg_user_id'
              })

              if (response.data.user.status === 'pending_payment' && !response2.data.length) {
                this.$cookies.set('payment_data', {
                  order_id: null,
                  type_of_user: 'gd',
                  type_of_order: 'registration',
                  items: [{
                    name: 'Registration Fee',
                    desc: 'Guider registration, included StarGuides\'s Scarf',
                    qty: 1,
                    currency: 'EUR',
                    price: 20
                  }]
                })

                this.$router.push({name: 'Pay_Now'})
              } else {
                this.$router.push({ name: 'MyAccount' })
              }
            } else {
              if (this.whereTo) this.$router.push({ name: this.whereTo })
              else this.$router.push({ name: 'MyAccount' })
            }
          }
        } catch (error) {
          let msg = error.response.data
          if (msg === `Your account seems to be broken or You need to confirm email first, please contact our admin to continue.`) {
            swal({
              title: 'Login Failed',
              text: msg,
              icon: 'error',
              buttons: {
                text: 'Ok',
                send: {
                  text: `Re-send Email`,
                  value: `resend`
                }
              }
            }).then(async test => {
              if (test === `resend`) {
                await AuthenticationAPI.resendEmailConfirmation(this.user)
              }
            })
          } else {
            swal({
              title: 'Login Failed',
              text: msg,
              icon: 'error',
              button: {
                text: 'Ok'
              }
            })
          }

          this.login_button_state = false
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scope>
  .sg-sub-heading-text {
    color: #233c7c;
    font-size: 32px;
    font-weight: 600;
  }

  .swal-modal {
    border-radius: 15px;
  }
  .swal-button {
    border-radius: 10px;
  }
  .swal-button {
    background-color: #3e5d8f !important;
  }
  .swal-button:hover {
    background-color: #869ab9 !important;
  }
  .swal-footer {
    text-align: center;
  }
  .swal-overlay {
    background-color: #56719d80;
  }
</style>



// WEBPACK FOOTER //
// src/templates/FormLogin/FormLogin.vue